import * as types from "./mutation-type";
import { getExemptionsQuery,getStoreExemptionsQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getExemptions({ commit }, variables = {}) {
    try {
      commit(types.GET_EXEMPTIONS_BEGIN);
      const {
        data: {
          data
        }
      } = await gqlClient.query({
        query     : variables.isStore ? getStoreExemptionsQuery : getExemptionsQuery,
        variables : variables
      });
      commit(types.GET_EXEMPTIONS_SUCCESS, variables.isStore ? data.store.exemptions : data.company.exemptions);
    } catch (e) {
      commit(types.GET_EXEMPTIONS_ERROR, e);
    }
  },
  async deleteExemption({ commit }, id) {
    try {
      commit(types.DELETE_EXEMPTION_BEGIN);
      await api.exemption.deleteExemption(id);
      commit(types.DELETE_EXEMPTION_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_EXEMPTION_ERROR, e);
    }
  },

  async createExemption({ commit }, variables ) { 
    try {
      commit(types.CREATE_EXEMPTION_BEGIN)
      const { data } = await api.exemption.addExemption(variables)
      commit(types.CREATE_EXEMPTION_SUCCESS, data)
    } catch (e) {
      commit(types.CREATE_EXEMPTION_ERROR, e)
    }
  },
  async updateExemption({ commit }, { id, data }){
    commit(types.UPDATE_EXEMPTION_BEGIN)
    try {
      const { data : updatedData } = await api.exemption.update(id, data)
      commit(types.UPDATE_EXEMPTION_SUCCESS, updatedData)
    } catch (error) {
      commit(types.UPDATE_EXEMPTION_ERROR, error)
    }
  },

  //assign exemption to particular user
  async createUserExemption({ commit, rootState }, userData) { 
    try {
      commit(types.ADD_USER_EXEMPTION_BEGIN, userData.userId)
      const { data } = await api.userExemption.addUserExemption(userData)
      commit(types.ADD_USER_EXEMPTION_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_USER_EXEMPTION_ERROR, { err, userId : userData.userId })
    }
  },

  //un-assign exemption to particular user
  async deleteUserExemption({ commit, rootState }, { id, userId }) {
    try {
      commit(types.DELETE_USER_EXEMPTION_BEGIN, userId);
      await api.userExemption.deleteUserExemp(id);
      commit(types.DELETE_USER_EXEMPTION_SUCCESS, { userId, rootState });
    } catch (err) {
      commit(types.DELETE_USER_EXEMPTION_ERROR, { err, userId });
    }
  },

  //assign task exemption to particular user
  async createTaskExemption({ commit, rootState }, userData) { 
    try {
      commit(types.ADD_TASK_EXEMPTION_BEGIN, userData.taskId)
      const { data } = await api.taskExemption.addTaskExemption(userData)
      commit(types.ADD_TASK_EXEMPTION_SUCCESS, { data, rootState })
    } catch (err) {
      commit(types.ADD_TASK_EXEMPTION_ERROR, { err, taskId : userData.taskId })
    }
  },
  
  //un-assign task exemption to particular user
  async deleteTaskExemption({ commit, rootState }, { id, taskId }) {
    try {
      commit(types.DELETE_TASK_EXEMPTION_BEGIN, taskId);
      await api.taskExemption.deleteTaskExemp(id);
      commit(types.DELETE_TASK_EXEMPTION_SUCCESS, { taskId, rootState });
    } catch (err) {
      commit(types.DELETE_TASK_EXEMPTION_ERROR, { err, taskId });
    }
  }
};

export default actions;
